var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
const cartDrawer = () => {
    // Free Gift
    if (document.body.hasAttribute('data-free-gift-promo')) {
        const freeGiftCriteriaCollection = document.body.getAttribute('data-free-gift-promo-collection');
        const freeGiftProduct = parseInt(document.body.getAttribute('data-free-gift-promo-product'));
        const freeGiftVariant = document.body.getAttribute('data-free-gift-promo-variant');
        const freeGiftSpend = document.body.getAttribute('data-free-gift-promo-spend');
        if (freeGiftProduct && freeGiftVariant) {
            let cartItems = null;
            let totalSpend = null;
            let itemsEligibleForFreeGift = null;
            const getItemsEligibleForFreeGift = () => __awaiter(void 0, void 0, void 0, function* () {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        fetch('/collections/' + freeGiftCriteriaCollection + '?view=json')
                            .then((response) => {
                            return response.json();
                        })
                            .then((data) => {
                            itemsEligibleForFreeGift = data.products;
                            resolve('');
                        });
                    }, 0);
                });
            });
            const updateMiniCart = () => {
                document.dispatchEvent(new CustomEvent('cart:refresh'));
            };
            const addGiftToCart = () => {
                const giftData = {
                    id: freeGiftVariant,
                    quantity: 1,
                };
                fetch('/cart/add.js', {
                    body: JSON.stringify(giftData),
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'xmlhttprequest',
                    },
                    method: 'POST',
                })
                    .then((response) => {
                    return response.json();
                })
                    .then((json) => {
                    updateMiniCart();
                })
                    .catch((err) => {
                    console.error(err);
                });
            };
            const removeGiftFromCart = () => {
                const giftData = {
                    id: freeGiftVariant,
                    quantity: 0,
                };
                fetch('/cart/change.js', {
                    body: JSON.stringify(giftData),
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'xmlhttprequest',
                    },
                    method: 'POST',
                })
                    .then((response) => {
                    return response.json();
                })
                    .then((json) => {
                    updateMiniCart();
                })
                    .catch((err) => {
                    console.error(err);
                });
            };
            const checkForSpendEligibility = () => {
                const cartItemsArr = [];
                for (const [key, value] of Object.entries(cartItems)) {
                    const productInfo = value;
                    cartItemsArr.push(productInfo.product_id);
                }
                const giftIsInCart = cartItemsArr.includes(freeGiftProduct);
                const userRemovedFreeGift = localStorage.getItem('user-removed-free-gift') || 'false';
                if (Number(totalSpend) / 100 < Number(freeGiftSpend)) {
                    if (giftIsInCart) {
                        removeGiftFromCart();
                    }
                    document.body.setAttribute('data-free-gift-promo-message', 'hide');
                    return null;
                }
                else {
                    if (!giftIsInCart) {
                        if (userRemovedFreeGift == 'true') {
                            document.body.setAttribute('data-free-gift-promo-message', 'show');
                        }
                        else {
                            document.body.setAttribute('data-free-gift-promo-message', 'hide');
                            addGiftToCart();
                        }
                    }
                }
            };
            const updateGiftIfInCollection = () => {
                const cartItemsArr = [];
                for (const [key, value] of Object.entries(cartItems)) {
                    const productInfo = value;
                    cartItemsArr.push(productInfo.product_id);
                }
                const userRemovedFreeGift = localStorage.getItem('user-removed-free-gift') || 'false';
                const itemsAreEligible = cartItemsArr.some((r) => itemsEligibleForFreeGift.indexOf(r) >= 0);
                const giftIsInCart = cartItemsArr.includes(freeGiftProduct);
                if (freeGiftSpend != '') {
                    if (Number(totalSpend) / 100 < Number(freeGiftSpend)) {
                        if (giftIsInCart) {
                            removeGiftFromCart();
                        }
                        document.body.setAttribute('data-free-gift-promo-message', 'hide');
                        return null;
                    }
                }
                if (itemsAreEligible) {
                    if (!giftIsInCart) {
                        if (userRemovedFreeGift == 'true') {
                            document.body.setAttribute('data-free-gift-promo-message', 'show');
                        }
                        else {
                            document.body.setAttribute('data-free-gift-promo-message', 'hide');
                            addGiftToCart();
                        }
                    }
                }
                else {
                    document.body.setAttribute('data-free-gift-promo-message', 'hide');
                    localStorage.setItem('user-removed-free-gift', 'false');
                    removeGiftFromCart();
                }
            };
            const checkFreeGiftEligibility = () => __awaiter(void 0, void 0, void 0, function* () {
                axios.get('/cart.js').then((res) => __awaiter(void 0, void 0, void 0, function* () {
                    cartItems = res.data.items;
                    totalSpend = res.data.total_price;
                    if (freeGiftSpend) {
                        checkForSpendEligibility();
                    }
                    else if (freeGiftCriteriaCollection) {
                        if (itemsEligibleForFreeGift == null) {
                            yield getItemsEligibleForFreeGift().then(() => {
                                updateGiftIfInCollection();
                            });
                        }
                        else {
                            updateGiftIfInCollection();
                        }
                    }
                }));
            });
            if (freeGiftSpend || freeGiftCriteriaCollection) {
                checkFreeGiftEligibility();
                document.addEventListener('cart:change', () => {
                    checkFreeGiftEligibility();
                });
                document.addEventListener('user-added-free-gift', () => {
                    localStorage.setItem('user-removed-free-gift', 'false');
                    checkFreeGiftEligibility();
                });
            }
        }
    }
    // BOGO
    if (document.body.hasAttribute('data-bogo-message') &&
        document.body.hasAttribute('data-bogo-threshold') &&
        document.body.hasAttribute('data-bogo-product-types')) {
        const bogoMessage = () => {
            let productsRequired = document.body.getAttribute('data-bogo-threshold');
            let message = document.body.getAttribute('data-bogo-message');
            const productTypes = document.body.getAttribute('data-bogo-product-types').split(',');
            const cartDrawerMessage = document.querySelector('[data-cart-drawer-bogo-message]');
            const checkBogoEligibility = () => {
                message = message.replace('{threshold}', productsRequired);
                if (cartDrawerMessage) {
                    cartDrawerMessage.setAttribute('data-bogo-countdown', productsRequired);
                    if (productsRequired <= 0) {
                        cartDrawerMessage.setAttribute('data-bogo-countdown', '0');
                    }
                    else {
                        cartDrawerMessage.innerHTML = message;
                        cartDrawerMessage.classList.add('cart-drawer__bogo-message--visible');
                    }
                }
            };
            const getCart = () => {
                axios
                    .get('/cart.js')
                    .then((res) => __awaiter(void 0, void 0, void 0, function* () {
                    const cartData = res.data;
                    return cartData;
                }))
                    .then((cartData) => {
                    const items = cartData.items;
                    items.forEach((item) => {
                        if (productTypes.includes(item.product_type)) {
                            const productQty = item.quantity;
                            productsRequired = productsRequired - productQty;
                        }
                    });
                })
                    .then(() => {
                    checkBogoEligibility();
                });
            };
            getCart();
        };
        bogoMessage();
        const events = ['cart:change', 'cart:refresh', 'variant:add', 'user-added-free-gift'];
        events.forEach((event) => {
            document.addEventListener(event, () => {
                setTimeout(() => {
                    bogoMessage();
                }, 1250);
            });
        });
    }
};
export { cartDrawer };
